import { render, staticRenderFns } from "./PDFViewerToolbarPageControl.vue?vue&type=template&id=49452894&scoped=true&lang=pug"
import script from "./PDFViewerToolbarPageControl.vue?vue&type=script&lang=ts"
export * from "./PDFViewerToolbarPageControl.vue?vue&type=script&lang=ts"
import style0 from "./PDFViewerToolbarPageControl.vue?vue&type=style&index=0&id=49452894&prod&lang=sass&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "49452894",
  null
  
)

export default component.exports